/* All intellectual property rights in the software, code and associated materials ("Software") belong to Leo Learning Limited and its licensors. All rights in the Software are expressly reserved by and to Leo Learning Limited and its licensors. Without limiting the generality of the foregoing, users of the Software are not permitted to (and agree not to) reproduce, copy or otherwise duplicate, and not to distribute, lend or otherwise transfer the Software or any part of it without the express written permission of Leo Learning Limited. Each user also undertakes not to use the Software in any way that would compromise the confidential and proprietary nature of the Software. Each user undertakes to use the Software only in accordance with the terms of the respective user license and not to resell, reproduce, sell, modify the Software in any way and acknowledges that it has no permission to so do. */ // eslint-disable-line max-len
import React from 'react'; // eslint-disable-line
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import ReactRouterPropTypes from 'react-router-prop-types';
import { withRouter } from 'react-router';
import { Route, Switch } from 'react-router-dom';

import { isPending } from 'consts/requestStates';
import Loading from 'components/Loading';
import Dashboard from 'components/dashboard/Dashboard';
import TenantsPage from 'components/tenants/TenantsPage';
import CreateTenantPage from 'components/tenants/CreateTenantPage';
import EditTenantPage from 'components/tenants/EditTenantPage';
import EditTenantPassesPage from 'components/tenants/EditTenantPassesPage';
import EditTenantPassPage from 'components/tenants/EditTenantPassPage';
import CreateTenantPassPage from 'components/tenants/CreateTenantPassPage';
import OfficesPage from 'components/offices/OfficesPage';
import CreateOfficePage from 'components/offices/CreateOfficePage';
import EditOfficePage from 'components/offices/EditOfficePage';
import EditOfficePassesPage from 'components/offices/EditOfficePassesPage';
import ReportDashboard from 'components/reports/ReportDashboard';
import CourseReport from 'components/reports/CourseReport';
import UsersPage from 'components/users/UsersPage';
import CreateUserPage from 'components/users/CreateUserPage';
import EditUserPage from 'components/users/EditUserPage';
import ProfilePage from 'components/users/ProfilePage';
import SearchUsersPage from 'components/users/SearchUsersPage';
import AuditLogPage from 'components/logs/AuditLogPage';
import { logout, getUserInfo, GET_USER_INFO } from 'actions/asyncActions';
import TopBar from './TopBar';
import Header from './Header';
import Footer from './Footer';
import PageNotFound from './PageNotFound';


export class LoggedInApp extends React.PureComponent {
  componentWillMount() {
    if (this.hasNoUser()) {
      this.props.getUserInfo();
    }
  }

  componentDidUpdate() {
    if (this.hasNoUser()) {
      this.props.history.push('/login/');
    }
  }

  hasNoUser() {
    const { loggedOnUser, requestState } = this.props;
    return loggedOnUser.isEmpty() && !isPending(requestState);
  }

  render() {
    const { loggedOnUser } = this.props;

    if (loggedOnUser.isEmpty()) {
      return <Loading />;
    }

    return (
      <div>
        <Header />
        <TopBar user={loggedOnUser} logout={this.props.logout} />

        <div className="row medium-8 large-7 columns">
          <Switch>
            <Route exact path="/" component={Dashboard} />
            <Route exact path="/tenants/" component={TenantsPage} />
            <Route exact path="/tenants/create/" component={CreateTenantPage} />
            <Route exact path="/tenants/:id/" component={EditTenantPage} />
            <Route exact path="/tenants/:id/passes/" component={EditTenantPassesPage} />
            <Route
              exact
              path="/tenants/:tenantId/passes/create/"
              component={CreateTenantPassPage}
            />
            <Route exact path="/tenants/:tenantId/passes/:passId/" component={EditTenantPassPage} />
            <Route exact path="/offices/" component={OfficesPage} />
            <Route exact path="/offices/create/" component={CreateOfficePage} />
            <Route exact path="/offices/:id/" component={EditOfficePage} />
            <Route exact path="/offices/:id/passes/" component={EditOfficePassesPage} />
            <Route exact path="/reports/" component={ReportDashboard} />
            <Route exact path="/reports/course/" component={CourseReport} />
            <Route exact path="/users/" component={UsersPage} />
            <Route exact path="/users/create/" component={CreateUserPage} />
            <Route exact path="/search/" component={SearchUsersPage} />
            <Route exact path="/users/:id/" component={EditUserPage} />
            <Route exact path="/profile/" component={ProfilePage} />
            <Route exact path="/auditlog/" component={AuditLogPage} />

            <Route component={PageNotFound} />
          </Switch>
        </div>

        <Footer />
      </div>
    );
  }
}
LoggedInApp.propTypes = {
  getUserInfo: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  loggedOnUser: ImmutablePropTypes.map.isRequired,
  requestState: ImmutablePropTypes.map,
  history: ReactRouterPropTypes.history.isRequired,
};
LoggedInApp.defaultProps = {
  requestState: null,
};

export function mapStateToProps(state) {
  return {
    loggedOnUser: state.loggedOnUser,
    requestState: state.requestStates.get(GET_USER_INFO),
  };
}

export default withRouter(connect(mapStateToProps, { logout, getUserInfo })(LoggedInApp));
